__turbopack_context__.v({
  "filterContent": "FilterPanel-module-scss-module__fwMNVa__filterContent",
  "filterOpen": "FilterPanel-module-scss-module__fwMNVa__filterOpen",
  "leftBar": "FilterPanel-module-scss-module__fwMNVa__leftBar",
  "leftBarWrapper": "FilterPanel-module-scss-module__fwMNVa__leftBarWrapper",
});
